import { render, staticRenderFns } from "./PerksTab.vue?vue&type=template&id=1015b801&scoped=true"
import script from "./PerksTab.vue?vue&type=script&lang=js"
export * from "./PerksTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1015b801",
  null
  
)

export default component.exports